import React from "react";
import { connect } from "react-redux";
import {
	Button,
	Modal,
	Form,
	FormGroup,
	FormControl,
	ControlLabel,
	Checkbox,
	Glyphicon,
	Row,
	Col, Table
} from "react-bootstrap";
import { debounce } from "throttle-debounce";
import { Event } from "components/Comet";
import Loading from "components/Loading";
import axios from "axios";
import locale from "locale";
import Select from "react-select";

const displays = [
    {label: "в Трансляции", value: "broadcast"},
    {label: "в Зале", value: "halls"},
    {label: "Везде", value: ""},
]

class PollAnswerEdit extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.saveProperty = this.saveProperty.bind(this);
		this.remove = this.remove.bind(this);

		this.state = {
			isLoaded: false,
		};
	}

	resetState({ textRu, textEn, ratingMax }) {
		const state = {
			textRu,
			textEn,
			ratingMax,
			isLoaded: true,
		};

		this.setState(state);
	}

	saveProperty(key, value) {
		const { event, poll, answer } = this.props;

		if (answer[key] === value) {
			return;
		}

		axios.put(`/api/cp/event/${event.eventPassword}/poll/${poll.id}/answer/${answer.id}`, { [key]: value });
	}

	remove() {
		const { event, poll, answer } = this.props;

		axios.delete(`/api/cp/event/${event.eventPassword}/poll/${poll.id}/answer/${answer.id}`);
	}

	componentDidMount() {
		const { answer } = this.props;

		this.resetState(answer);
	}

	UNSAFE_componentWillReceiveProps(props) {
		const { answer } = props;

		this.resetState(answer);
	}

	render() {
		const { poll } = this.props;

		if (!this.state.isLoaded) {
			return (
				<tr>
					<td>Answer</td>
				</tr>
			);
		}

		if ('rating' === poll.type) {
			return (
				<tr>
					<td style={{ width: '45%' }}>
						<FormControl
							type="text"
							value={this.state.textRu}
							onChange={e => this.setState({ textRu: e.target.value })}
							onBlur={e => this.saveProperty('textRu', e.target.value)}
							placeholder="Название"
						/>
					</td>
					<td style={{ width: '45%' }}>
						<FormControl
							type="text"
							value={this.state.textEn}
							onChange={e => this.setState({ textEn: e.target.value })}
							onBlur={e => this.saveProperty('textEn', e.target.value)}
							placeholder="Title"
						/>
					</td>
					<td style={{ width: '10%' }}>
						<FormControl
							type="number"
							value={this.state.ratingMax}
							max={10}
							min={2}
							onChange={e => this.setState({ ratingMax: e.target.value })}
							onBlur={e => this.saveProperty('ratingMax', e.target.value)}
						/>
					</td>
					<td style={{ width: '10px' }}>
						<Button onClick={this.remove}>
							<Glyphicon glyph="remove" />
						</Button>
					</td>
				</tr>
			);
		}

		return (
			<tr>
				<td style={{ width: '50%' }}>
					<FormControl
						type="text"
						value={this.state.textRu}
						onChange={e => this.setState({ textRu: e.target.value })}
						onBlur={e => this.saveProperty('textRu', e.target.value)}
						placeholder="Вариант ответа" />
				</td>
				<td style={{ width: '50%' }}>
					<FormControl
						type="text"
						value={this.state.textEn}
						onChange={e => this.setState({ textEn: e.target.value })}
						onBlur={e => this.saveProperty('textEn', e.target.value)}
						placeholder="Answer" />
				</td>
				<td style={{ width: '10px' }}>
					<Button onClick={this.remove}>
						<Glyphicon glyph="remove" />
					</Button>
				</td>
			</tr>
		);
	}
}

class PollEdit extends React.Component {
	state = {
		isLoading: true,
		isShow: false,
		colors: [],
	};

	constructor(props, context) {
		super(props, context);

		this.changeProperty = this.changeProperty.bind(this);

		this.saveProperty = debounce(300, this.saveProperty.bind(this));
		this.savePropertyFile = this.savePropertyFile.bind(this);

		this.createAnswer = this.createAnswer.bind(this);

		this.onUpdatePoll = this.onUpdatePoll.bind(this);
		this.onUpdateAnswer = this.onUpdateAnswer.bind(this);
		this.onDeleteAnswer = this.onDeleteAnswer.bind(this);

		this.resetState = this.resetState.bind(this);
		this.mapAnswerNumberOption = this.mapAnswerNumberOption.bind(this);
		this.imageInputRef = React.createRef();
		this.backgroundImageInputRef = React.createRef();
	}

	resetState(poll) {
		const state = {
			poll: null,
			editPoll: null,
			answers: [],
			isLoading: false,
			isShow: true,
			colors: [],
		};

		if (poll) {
			state.poll = {
				id: poll.id,
				streamId: poll.streamId,
				imageUrl: poll.imageUrl,
				textRu: poll.textRu,
				textEn: poll.textEn,
				'private': poll.private,
				percentage: poll.percentage,
				multiple: poll.multiple,
				object: poll.object,
				authorizationRequired: poll.authorizationRequired,
				type: poll.type,
				backgroundImageUrl: poll.backgroundImageUrl,
				answerNumber: poll.answerNumber,
				options: poll.options,
                display: poll.display,
			};
			state.editPoll = {
				textRu: poll.textRu,
				textEn: poll.textEn,
				object: poll.object,
				options: poll.options,
			};

			state.answers = poll.answer.map(answer => ({
				id: answer.id,
				textRu: answer.textRu,
				textEn: answer.textEn,
				ratingMax: answer.ratingMax,
			}));

			state.colors = poll?.options?.answerColors || [];
		}

		this.setState(state);
	}

	saveProperty(key, value) {
		if (this.state[key] === value) {
			return;
		}

		const { event } = this.props;
		const { poll } = this.state;

		axios.put(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, { [key]: value })
			.then(response => response.data)
			.then(this.onUpdatePoll)
			;
	}

	savePropertyFile(key, file) {

		const { event } = this.props;
		const { poll } = this.state;

		const formData = new FormData();
		formData.append(key, file);

		axios.post(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, formData)
			.then(response => response.data)
			.then(this.onUpdatePoll)
			;

		// if (file === "DELETE") {
		// 	this.imageInputRef.current.value = null;
		// 	this.backgroundImageInputRef.current = null;
		// }
	}

	changeProperty(key, value) {
		const editPoll = Object.assign({}, this.state.editPoll, { [key]: value });

		this.setState({ editPoll });
	}

	saveOption(option, value) {
		if (this.saveOptionsTimeout) {
			clearTimeout(this.saveOptionsTimeout);
		}

		const { poll } = this.state;
		const options = { ...poll.options, ...{ [option]: value } };

		this.saveOptionsTimeout = setTimeout(() => {
			const { event } = this.props;
			axios.put(`/api/cp/event/${event.eventPassword}/poll/${poll.id}`, { options: options })
				.then(response => response.data)
				;
		}, 1000);
	}

	saveColors() {
		setTimeout(() => {
			const { colors } = this.state;

			this.saveOption('answerColors', colors);
		}, 0);
	}

	setColors(colors) {
		this.setState({ colors });
	}

	addColor(color) {
		const colors = [...this.state.colors, color];
		this.setColors(colors);
		this.saveColors();
	}

	updateColor(index, color) {
		const colors = [...this.state.colors];
		colors[index] = color;
		this.setColors(colors);
		this.saveColors();
	}

	removeColor(index) {
		const colors = [...this.state.colors];
		colors.splice(index, 1);
		this.setColors(colors);
		this.saveColors();
	}

	createAnswer() {
		const { event } = this.props;
		const { poll } = this.state;

		axios.post(`/api/cp/event/${event.eventPassword}/poll/${poll.id}/answer`)
			.then(response => response.data)
			.then(this.onUpdateAnswer)
			;
	}

	onUpdatePoll(poll) {
		const { pollId } = this.props;

		if (pollId !== poll.id) {
			return;
		}

		this.resetState(poll);
	}

	onUpdateAnswer(answer) {
		const { pollId } = this.props;

		if (pollId !== answer.pollId) {
			return;
		}

		const answers = this.state.answers.slice();
		const index = answers.findIndex(a => a.id === answer.id);

		if (-1 === index) {
			answers.push(answer);
		} else {
			answers[index] = Object.assign({}, answers[index], answer);
		}
		this.setState({ answers });
	}

	onDeleteAnswer(answer) {
		let { answers } = this.state;
		const index = answers.findIndex(a => a.id === answer.id);
		if (-1 === index) {
			return;
		}

		answers.splice(index, 1);
		this.setState({ answers });
	}

	UNSAFE_componentWillReceiveProps(props) {
		const { event, pollId } = props;
		const { poll } = this.state;

		if (!pollId) {
			this.setState({ poll: null, editPoll: null, isShow: false });

			return;
		}

		if (poll && poll.id === pollId) return;

		this.setState({ isLoading: true, isShow: true });
		axios.get(`/api/cp/event/${event.eventPassword}/poll/${pollId}`)
			.then(response => response.data)
			.then(this.onUpdatePoll)
			;
	}

	mapAnswerNumberOption(value) {
		return {
			label: value,
			value,
		};
	}

	render() {
		const { onCancel, event } = this.props;
		const { poll, editPoll, answers, isLoading, isShow, colors } = this.state;
		const answerNumberOptions = [1, 2, 3].map(this.mapAnswerNumberOption);

		return (
			<Modal show={isShow} onHide={onCancel} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Редактирование опроса</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{isLoading || !poll ?
						<Loading>Загрузка данных опроса</Loading>
						:
						<Form>
							<FormGroup>
								<ControlLabel>Зал</ControlLabel>
								<FormControl componentClass="select" value={poll.streamId} onChange={e => this.saveProperty('streamId', parseInt(e.target.value))}>
									{event.stream.map(stream => <option value={stream.id} key={stream.streamKey}>{stream.description_ru}</option>)}
								</FormControl>
							</FormGroup>
							{'standard' === poll.type &&
								<FormGroup>
									<Checkbox
										checked={!poll.authorizationRequired}
										onChange={e => this.saveProperty('authorizationRequired', !e.target.checked)}
										inline
									>
										Голосовать анонимно
									</Checkbox>
									<Checkbox
										checked={poll.private}
										onChange={e => this.saveProperty('private', e.target.checked)}
										inline
									>
										Скрывать результаты
									</Checkbox>
									<Checkbox
										checked={poll.percentage}
										onChange={e => this.saveProperty('percentage', e.target.checked)}
										inline
									>
										Результаты в процентах
									</Checkbox>
									<Checkbox
										checked={poll.multiple}
										onChange={e => this.saveProperty('multiple', e.target.checked)}
										inline
									>
										Несколько ответов
									</Checkbox>
								</FormGroup>
							}
							{['open', 'rating'].includes(poll.type) &&
								<FormGroup>
									<Checkbox
										checked={!poll.authorizationRequired}
										onChange={e => this.saveProperty('authorizationRequired', !e.target.checked)}
										inline
									>
										Голосовать анонимно
									</Checkbox>
									<Checkbox
										checked={poll.private}
										onChange={e => this.saveProperty('private', e.target.checked)}
										inline
									>
										Скрывать результаты
									</Checkbox>
								</FormGroup>
							}
							<FormGroup>
								<Row>
                                    <Col xs={6}>
                                        <ControlLabel>Где показывать опрос</ControlLabel>
                                        <FormControl componentClass="select" value={poll.display || ""} onChange={e => this.saveProperty('display', e.target.value)}>
                                            {displays.map(item => <option value={item.value} key={item.value}>{item.label}</option>)}
                                        </FormControl>
									</Col>
									<Col xs={6}>
										<FormGroup>
											<ControlLabel>Изображение вопроса</ControlLabel>
											{poll.imageUrl && <div><img src={poll.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
											<div>
												<Button onClick={() => this.imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
												{' '}
												{poll.imageUrl && <Button onClick={() => this.savePropertyFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
											</div>
											<FormControl
												type="file"
												onChange={(e) => this.savePropertyFile('image', e.target.files[0] || null)}
												inputRef={ref => this.imageInputRef.current = ref}
												style={{ display: 'none' }}
											/>
										</FormGroup>
									</Col>
								</Row>
							</FormGroup>
							{'open' === poll.type &&
								<>
									<FormGroup>
										<Row>
											<Col xs={6}>
												<ControlLabel>Вопрос [Ru]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textRu}
													onChange={e => this.changeProperty('textRu', e.target.value)}
													onBlur={(e) => this.saveProperty('textRu', e.target.value)}
													placeholder="Вопрос"
												/>
											</Col>
											<Col xs={6}>
												<ControlLabel>Вопрос [En]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textEn}
													onChange={e => this.changeProperty('textEn', e.target.value)}
													onBlur={(e) => this.saveProperty('textEn', e.target.value)}
													placeholder="Question"
												/>
											</Col>
										</Row>
									</FormGroup>
									<FormGroup>
										<ControlLabel>{locale('label.poll.answerNumber')}</ControlLabel>
										<Select
											placeholder={locale('placeholder.selectValue')}
											isClearable={false}
											isSearchable={false}
											options={answerNumberOptions}
											onChange={option => this.saveProperty('answerNumber', option.value)}
											defaultValue={this.mapAnswerNumberOption(poll.answerNumber)}
										/>
									</FormGroup>
									<FormGroup>
										<ControlLabel>{locale('label.poll.answerColors')}</ControlLabel>
										<div className="colors">
											{colors.map((color, index) => (
												<div
													key={index}
													className="color-item"
												>
													<span><b>{index + 1}</b> по популярности</span>
													<input
														type="color"
														value={color}
														onChange={(e) => this.updateColor(index, e.target.value)}
													/>
													<div
														className="color-item-remove"
														onClick={() => this.removeColor(index)}
													>
														×
													</div>
												</div>
											))}
											{colors.length < 5 &&
												<a
													className="btn btn-default answer-colors"
													onClick={() => this.addColor('#ffffff')}
												>
													+
												</a>
											}
										</div>
									</FormGroup>
									<FormGroup>
										<Row>
											<Col xs={6}>
												<FormGroup>
													<ControlLabel>Фоновое изображение</ControlLabel>
													{poll.backgroundImageUrl && <div><img src={poll.backgroundImageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
													<div>
														<Button onClick={() => this.backgroundImageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
														{' '}
														{poll.backgroundImageUrl && <Button onClick={() => this.savePropertyFile('backgroundImage', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
													</div>
													<FormControl
														type="file"
														onChange={(e) => this.savePropertyFile('backgroundImage', e.target.files[0] || null)}
														inputRef={ref => this.backgroundImageInputRef.current = ref}
														style={{ display: 'none' }}
													/>
												</FormGroup>
											</Col>
										</Row>
									</FormGroup>
								</>
							}
							{'rating' === poll.type &&
								<>
									<FormGroup>
										<Row>
											<Col xs={6}>
												<ControlLabel>Вопрос [Ru]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textRu}
													onChange={e => this.changeProperty('textRu', e.target.value)}
													onBlur={(e) => this.saveProperty('textRu', e.target.value)}
													placeholder="Вопрос"
												/>
											</Col>
											<Col xs={6}>
												<ControlLabel>Вопрос [En]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textEn}
													onChange={e => this.changeProperty('textEn', e.target.value)}
													onBlur={(e) => this.saveProperty('textEn', e.target.value)}
													placeholder="Question"
												/>
											</Col>
										</Row>
									</FormGroup>
									<FormGroup>
										<Row>
											<Col xs={12}>
												<ControlLabel>Объект</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.object}
													onChange={e => this.changeProperty('object', e.target.value)}
													onBlur={(e) => this.saveProperty('object', e.target.value)}
													placeholder="Объект"
												/>
											</Col>
										</Row>
									</FormGroup>
									<FormGroup>
										<Table>
											<thead>
												<tr>
													<th><ControlLabel>Критерий [Ru]</ControlLabel></th>
													<th><ControlLabel>Критерий [En]</ControlLabel></th>
													<th><ControlLabel>Размер шкалы</ControlLabel></th>
													<th>{' '}</th>
												</tr>
											</thead>
											<tbody>
												{answers.sort((a, b) => a.order - b.order).map((answer, index) =>
													<PollAnswerEdit
														event={event}
														poll={poll}
														answer={answer}
														key={`poll_answer_${index}`} />
												)}
											</tbody>
										</Table>
									</FormGroup>

									<FormGroup>
										<Button onClick={this.createAnswer}>Добавить критерий</Button>
									</FormGroup>
								</>
							}
							{'standard' === poll.type &&
								<>
									<FormGroup>
										<Row>
											<Col xs={6}>
												<ControlLabel>Вопрос [Ru]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textRu}
													onChange={e => this.changeProperty('textRu', e.target.value)}
													onBlur={(e) => this.saveProperty('textRu', e.target.value)}
													placeholder="Вопрос" />
											</Col>
											<Col xs={6}>
												<ControlLabel>Вопрос [En]</ControlLabel>
												<FormControl
													type="textarea"
													value={editPoll.textEn}
													onChange={e => this.changeProperty('textEn', e.target.value)}
													onBlur={(e) => this.saveProperty('textEn', e.target.value)}
													placeholder="Question" />
											</Col>
										</Row>
									</FormGroup>

									<FormGroup>
										<Table>
											<thead>
												<tr>
													<th><ControlLabel>Ответ [Ru]</ControlLabel></th>
													<th><ControlLabel>Ответ [En]</ControlLabel></th>
													<th>{' '}</th>
												</tr>
											</thead>
											<tbody>
												{answers.sort((a, b) => a.order - b.order).map((answer, index) =>
													<PollAnswerEdit
														event={event}
														poll={poll}
														answer={answer}
														key={`poll_answer_${index}`} />
												)}
											</tbody>
										</Table>
									</FormGroup>

									<FormGroup>
										<Button onClick={this.createAnswer}>Добавить вариант ответа</Button>
									</FormGroup>
								</>
							}
							<Event event="update:poll" handler={this.onUpdatePoll.bind(this)} />

							<Event event="create:poll/answer" handler={this.onUpdateAnswer.bind(this)} />
							<Event event="update:poll/answer" handler={this.onUpdateAnswer.bind(this)} />
							<Event event="delete:poll/answer" handler={this.onDeleteAnswer.bind(this)} />
						</Form>

					}
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onCancel}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		)
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PollEdit);
